import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import CustomTranslation from "core/customTranslation";
import {useContext, useEffect, useState} from "react";
import {DragDropContext, Draggable, Droppable} from "@hello-pangea/dnd";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import Offcanvas from "react-bootstrap/Offcanvas";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import TabProgramming from "./TabProgramming";
import ModalSelectGrouped from "site-apps/assets/components/ModalSelectGrouped";
import ModalWaypointSelects from "site-apps/distribution/waypoints/ModalWaypointSelects";
import {SwalAlertClass} from "core/swalClass";
import TabData from "./TabData";
import RouteAssetCard from "site-apps/distribution/route/RouteAssetCard";
import RouteWaypointCard from "site-apps/distribution/route/RouteWaypointCard";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import axiApi from "ApiCaller";
import MapRouteCalculatorManager from "./MapRouteCalculatorManager";
import InstantiateRouteStatic from "./InstantiateRouteStatic";
import AuthContext from "context/AuthContext";
import {RouteWaypointModel} from "site-apps/distribution/route/RouteWaypointModel";

const translations = {
    es: {
        "error_form": "Error en el formulario.",
        "load_type": "Se necesitan tipos de cargas y tipos de residuos.",
        "pending_route": "Pendiente calcular ruta",
        "calcule_route": "Debe calcular la ruta antes de guardar.",
        "not_posible": "No es posible",
        "select_load_waste": "¡Se debe seleccionar un tipo de fracción y un tipo de carga!",
        "route_saved": "Ruta guardada",
        "route_saved_desc": "La ruta se ha guardado correctamente",
        "service_error": "Error en el servicio",
        "server_error": "Error en el servidor",
        "service_error_desc": "Consultar con el administrador.",
        "invalid_data": "Los datos enviados no son correctos.",

    },
    en: {
        "error_form": "Error in the form.",
        "load_type": "Load types and waste types are required.",
        "pending_route": "Pending route calculation",
        "calcule_route": "You must calculate the route before saving.",
        "not_posible": "Not possible",
        "select_load_waste": "You must select a load type and a waste type!",
        "route_saved": "Route saved",
        "route_saved_desc": "The route has been saved successfully",
        "service_error": "Error in the service",
        "server_error": "Error in the server",
        "service_error_desc": "Consult with the administrator.",
        "invalid_data": "The sent data is not correct.",
    },
};

const FormRouteStatic = ({show, setShow, item, setItem, params, items, setItems}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = CustomTranslation(translations);
    const {panel} = useContext(AuthContext);
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});
    const [showModalAssets, setShowModalAssets] = useState(false);
    const [showModalWaypoints, setShowModalWaypoints] = useState(false);
    const [hasChanged, setHasChanged] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [downloads, setDownloads] = useState([...item.download_type]);
    const [wastes, setWastes] = useState([...item.waste_type]);
    const [waypoints, setWaypoints] = useState([...item.checkpoints]);
    const [wayAssets, setWayAssets] = useState([]);
    const [wayRefs, setWayRefs] = useState([]);
    const [geojson, setGeojson] = useState({...item.geojson});
    const [canSave, setCanSave] = useState(false);
    const [filtersModalAssets, setFiltersModalAssets] = useState({
        waste_type: "",
        download_type: "",
    });
    const [duration, setDuration] = useState(0);

    useEffect(() => {
        setDuration(parseInt(item.duration));
        setCanSave(Boolean(item.id));
        setWastes([item.waste_type]);
        setDownloads([item.download_type]);
        setGeojson({...item.geojson});
        const waypoints_ = [];
        const wayAssets_ = [];
        const wayRefs_ = [];

        item.checkpoints.forEach((_waypoint, idx) => {
            const waypoint_ = new RouteWaypointModel(_waypoint);
            if (waypoint_.is_asset) {
                waypoint_.createAsset();
                wayAssets_.push(waypoint_.asset);
            } else {
                waypoint_.createWaypoint();
                wayRefs_.push(waypoint_.waypoint);
            }
            waypoints_.push(waypoint_);
        });
        setWaypoints([...waypoints_]);
        setWayAssets([...wayAssets_]);
        setWayRefs([...wayRefs_]);
        if (item.geojson && !Object.keys(item.geojson).length) {
            setHasChanged(true);
        }
        return () => {
            unsubscribeEvent("assets:modal:selector", eventSelectAssets);
            unsubscribeEvent("waypoints:modal:selector", eventSelectWaypoint);
        };
    }, [item]);

    const handleClose = () => {
        setShow(false);
        setIsOpen(false);
    };

    const onChangeTypes = (e) => {
        const {value, checked, name} = e.target;
        let waste = [...wastes],
            download = [...downloads];
        switch (name) {
            case "waste":
                checked ? (waste = [value]) : (waste = []);
                break;
            case "download":
                checked ? (download = [value]) : (download = []);
                break;
            default:
                break;
        }
        setDownloads(download);
        setWastes(waste);
        setCanSave(Boolean(waste.length && download.length));
    };
    const onSubmit = (e) => {
        e.preventDefault();
        if (!wastes.length || !downloads.length) {
            Alert.warning(_TC("not_posible"), _TC("select_load_waste"));
            return false;
        }
        if (hasChanged) {
            Alert.warning(_TC("pending_route"), _TC("calcule_route"));
            return false;
        }
        const form = new FormData(e.target);
        form.set("wastes", wastes);
        form.set("downloads", downloads);
        const waypointsData = {assets: [], waypoints: []};
        waypoints.forEach((_waypoint) => {
            if (_waypoint.is_island) {
                _waypoint.asset_ids.forEach((aid) => {
                    waypointsData.assets.push({
                        id: aid,
                        order: _waypoint.order,
                        step: _waypoint.step,
                    });
                });
            } else if (_waypoint.is_asset) {
                waypointsData.assets.push({
                    id: _waypoint.asset_id,
                    order: _waypoint.order,
                    step: _waypoint.step,
                });
            } else {
                waypointsData.waypoints.push({
                    id: _waypoint.waypoint_id,
                    order: _waypoint.order,
                    step: _waypoint.step,
                });
            }
        });

        form.set("waypoints", JSON.stringify(waypointsData));
        axiApi
            .post("/api/distribution/static/route/", form)
            .then((resp) => {
                if (resp.data.status) {
                    if (form.get("idx")) {
                        const routes = [...items.current.showed];
                        const idx = parseInt(form.get("idx"));
                        routes[idx] = resp.data.item;
                        setItems([...routes]);
                        items.current.showed = [...routes];
                        items.current.all = items.current.all.concat(items.current.showed);
                        setItem({...resp.data.item});
                    } else {
                        setItems([...items.current.showed, resp.data.item]);
                        items.current.showed.push(resp.data.item);
                        items.current.all.push(resp.data.item);
                    }
                    Alert.success(_TC("route_saved"), _TC("route_saved_desc"));
                    setShow(false);
                } else {
                    Alert.error("", _TC("service_error_desc"));
                }
            })
            .catch((err) => {
                console.error("[FormRouter] Error al guardar la ruta");
                console.error(err);
                if (err.response.status === 400 || err.response.status === 404) {
                    Alert.error(_TC("server_error"), _TC("invalid_data"));
                } else {
                    Alert.error(_TC("server_error"), _TC("service_error_desc"));
                }
            });
    };

    const onClickSelectWaypoints = () => {
        subscribeEvent("waypoints:modal:selector", eventSelectWaypoint);
        setShowModalWaypoints(true);
    };

    const eventSelectWaypoint = (e) => {
        const currentIds = [];
        const selectedIds = [];
        waypoints.forEach((_point) => {
            if (!_point.is_asset) {
                currentIds.push(_point.waypoint_id);
            }
        });
        let waypoints_ = [...waypoints];
        let wayRefs_ = [...wayRefs];
        let orders = waypoints.length;
        e.detail.forEach((_waypoint) => {
            selectedIds.push(_waypoint.id);
            if (!currentIds.includes(_waypoint.id)) {
                orders++;
                const point = new RouteWaypointModel();
                _waypoint.order = orders;
                point.setWaypoint(_waypoint);
                waypoints_.push(point);
                wayRefs_.push(_waypoint);
            }
        });

        if (selectedIds.length) {
            waypoints_ = waypoints_.filter((_point) => {
                if (!_point.is_asset) {
                    return selectedIds.includes(_point.waypoint_id);
                }
                return true;
            });
            wayRefs_ = wayRefs_.filter((_ref) => selectedIds.includes(_ref.id));
        }

        setWaypoints(waypoints_);
        setWayRefs(wayRefs_);
        setHasChanged(true);
        unsubscribeEvent("waypoints:modal:selector", eventSelectWaypoint);
    };

    const onClickSelectAssets = () => {
        if (!wastes.length || !downloads.length) {
            Alert.warning(_TC("not_posible"), _TC("select_load_waste"));
            return false;
        }
        setFiltersModalAssets({
            waste_type: wastes[0],
            download_type: downloads[0],
        });
        setShowModalAssets(true);
        subscribeEvent("assets:modal:selector", eventSelectAssets);
    };

    function eventSelectAssets(e) {
        const currentIds = [];
        waypoints.forEach((_point) => {
            if (_point.is_asset && !_point.is_island) {
                currentIds.push(_point.asset_id);
            }
        });
        const islandCoveredIds = new Set();
        const selectedAssetIds = new Set();
        const selectedIslandIds = new Set();
        e.detail.assets.forEach((_asset) => {
            if (_asset.is_island) {
                selectedIslandIds.add(_asset.id);
                _asset.asset_ids.forEach((aid) => islandCoveredIds.add(aid));
            } else {
                selectedAssetIds.add(_asset.id);
            }
        });
        let waypoints_ = waypoints.filter((_point) => {
            if (_point.is_asset) {
                return _point.is_island
                    ? selectedIslandIds.has(_point.asset_id)
                    : selectedAssetIds.has(_point.asset_id);
            }
            return true;
        });
        let wayAssets_ = wayAssets.filter((_asset) =>
            selectedAssetIds.has(_asset.id) || selectedIslandIds.has(_asset.id)
        );
        let orders = waypoints_.length;
        e.detail.assets.forEach((_asset) => {
            if (_asset.is_island) {
                if (!waypoints_.find((wp) => wp.is_island && wp.asset_id === _asset.id)) {
                    orders++;
                    const point = new RouteWaypointModel();
                    _asset.order = orders;
                    point.setIsland(_asset);
                    waypoints_.push(point);
                    wayAssets_.push(_asset);
                }
            } else if (!currentIds.includes(_asset.id) && !islandCoveredIds.has(_asset.id)) {
                orders++;
                const point = new RouteWaypointModel();
                _asset.order = orders;
                point.setAsset(_asset);
                waypoints_.push(point);
                wayAssets_.push(_asset);
            }
        });
        setWaypoints(waypoints_);
        setWayAssets(wayAssets_);
        setHasChanged(true);
        unsubscribeEvent("assets:modal:selector", eventSelectAssets);
    }

    const dragEnded = (param) => {
        const {source, destination} = param;
        let _arr = [...waypoints];
        const _item = _arr.splice(source.index, 1)[0];
        _arr.splice(destination.index, 0, _item);
        _arr = _arr.map((_way, idx) => {
            _way.order = idx + 1;
            return _way;
        });
        setWaypoints(_arr);
        setHasChanged(true);
    };

    const handleDeleteWaypoint = (e) => {
        const idx = parseInt(e.currentTarget.value);
        const point = {...waypoints[idx]};
        const waypoints_ = [];
        let orders = 0;
        waypoints.forEach((_point, index) => {
            if (index !== idx) {
                orders++;
                _point.order = orders;
                waypoints_.push(_point);
            }
        });
        if (point.is_asset) {
            setWayAssets(wayAssets.filter((_asset) => _asset.id !== point.asset_id));
        } else {
            setWayRefs(wayRefs.filter((_ref) => _ref.id !== point.waypoint_id));
        }
        setWaypoints(waypoints_);
        setHasChanged(true);
    };
    const handleCopyWaypoint = (e) => {
        const idx = parseInt(e.currentTarget.value);
        const waypoint_ = {...waypoints[idx]};
        let order = waypoints.length + 1;
        waypoint_.id = "";
        waypoint_.order = order;
        setWaypoints([...waypoints, waypoint_]);
        if (waypoint_.is_asset) {
            setWayAssets([...wayAssets, waypoint_.asset]);
        } else {
            setWayRefs([...wayRefs, waypoint_.waypoint]);
        }
        setHasChanged(true);
    };
    return (
        <>
            {showModalWaypoints ? (
                <ModalWaypointSelects
                    show={showModalWaypoints}
                    setShow={setShowModalWaypoints}
                    chosenIn={wayRefs}
                    aria-modal="true"
                />
            ) : (
                <></>
            )}

            {showModalAssets ? (
                <ModalSelectGrouped
                    show={showModalAssets}
                    setShow={setShowModalAssets}
                    filtering={filtersModalAssets}
                    chosenIn={wayAssets}
                    multiple={true}
                    subtitle={"Ruta: " + item.name}
                    aria-modal="true"
                />
            ) : (
                <></>
            )}

            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="end"
                backdrop="static"
                aria-modal="true"
                style={{width: "688px", fontSize: "15px"}}
                tabIndex={show ? 0 : -1}>
                <Offcanvas.Header className="preview-canvas">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="location-dot" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>
                            {_Tf("routes.routes")} {_Tf("routes.static")}
                        </Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form className="row g-3" onSubmit={onSubmit}>
                        <input type="hidden" name="id" value={item.id} />
                        <input type="hidden" name="idx" value={item.idx} />
                        <input type="hidden" name="geojson" value={JSON.stringify(geojson)} />
                        <Tab.Container defaultActiveKey="data" id="tabs-form-routes">
                            <Nav variant="tabs">
                                <Nav.Item>
                                    <Nav.Link eventKey="data">{_Tf("common.data")}</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="containers" disabled={!(downloads.length && wastes.length)}>
                                        {_Tf("routes.containers")}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="map">{_Tf("labels.route")}</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="programming">{_Tf("routes.programmings")}</Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="ms-auto">
                                    <Nav.Link eventKey="instantiate" disabled={!item.id} title="Instanciar ruta hoy">
                                        Instanciar
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content>
                            <Tab.Pane eventKey="data">
                                <TabData
                                    item={item}
                                    params={params}
                                    downloads={downloads}
                                    onChangeTypes={onChangeTypes}
                                    wastes={wastes}
                                    _Tf={_Tf}
                                />
                            </Tab.Pane>
                            <Tab.Pane eventKey="containers" className="mb-5">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 mb-3">
                                            <div className="row">
                                                <div className="col-12 text-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-warning me-2"
                                                        onClick={() => {
                                                            setWaypoints([]);
                                                            setWayRefs([]);
                                                            setWayAssets([]);
                                                            setHasChanged(false);
                                                        }}
                                                        title={_Tf("common.clean")}>
                                                        <FontAwesomeIcon icon="broom" />
                                                    </button>
                                                    <DropdownButton
                                                        as={ButtonGroup}
                                                        id="dropdown-selector-containers"
                                                        variant="outline-primary"
                                                        title={<FontAwesomeIcon icon="pen" />}>
                                                        <Dropdown.Item eventKey="w" onClick={onClickSelectWaypoints}>
                                                            <FontAwesomeIcon icon="map-location-dot" /> {_Tf("routes.references")}
                                                        </Dropdown.Item>
                                                        <Dropdown.Item eventKey="a" onClick={onClickSelectAssets}>
                                                            <FontAwesomeIcon icon="dumpster" /> {_Tf("routes.containers")}
                                                        </Dropdown.Item>
                                                    </DropdownButton>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <DragDropContext onDragEnd={dragEnded}>
                                                <Droppable droppableId="assets">
                                                    {(provided) => (
                                                        <ul
                                                            className="dragable"
                                                            {...provided.droppableProps}
                                                            ref={provided.innerRef}>
                                                            {waypoints.map((_asset, index) =>
                                                                _asset.is_asset ? (
                                                                    <Draggable
                                                                        key={"drag-ass-" + (_asset.is_island ? "island-" + _asset.island_id : _asset.asset_id)}
                                                                        draggableId={"drag-id-ass-" + (_asset.is_island ? "island-" + _asset.island_id : _asset.asset_id)}
                                                                        index={index}>
                                                                        {(provided) => (
                                                                            <li
                                                                                className="row"
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}>
                                                                                <div className="col border rounded p-2 mb-3 bg-white">
                                                                                    <RouteAssetCard asset={_asset} />
                                                                                </div>
                                                                                <div
                                                                                    className="col p-0"
                                                                                    style={{
                                                                                        maxWidth: "29px",
                                                                                    }}>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-link text-body-tertiary"
                                                                                        title="Borrar"
                                                                                        value={index}
                                                                                        onClick={handleDeleteWaypoint}>
                                                                                        <FontAwesomeIcon icon="trash" size="xl" />
                                                                                    </button>
                                                                                </div>
                                                                            </li>
                                                                        )}
                                                                    </Draggable>
                                                                ) : (
                                                                    <Draggable
                                                                        key={"drag-way-" + _asset.waypoint_id + "-" + index}
                                                                        draggableId={
                                                                            "drag-id-way-" + _asset.waypoint_id + "-" + index
                                                                        }
                                                                        index={index}>
                                                                        {(provided) => (
                                                                            <li
                                                                                className="row"
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}>
                                                                                <div className="col border rounded p-2 mb-3 bg-white">
                                                                                    <RouteWaypointCard routeway={_asset} />
                                                                                </div>
                                                                                <div
                                                                                    className="col p-0"
                                                                                    style={{
                                                                                        maxWidth: "29px",
                                                                                    }}>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-link text-body-tertiary"
                                                                                        title="Borrar"
                                                                                        value={index}
                                                                                        onClick={handleDeleteWaypoint}>
                                                                                        <FontAwesomeIcon icon="trash" size="xl" />
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-link text-body-tertiary"
                                                                                        title="Copiar"
                                                                                        value={index}
                                                                                        onClick={handleCopyWaypoint}>
                                                                                        <FontAwesomeIcon icon="copy" size="xl" />
                                                                                    </button>
                                                                                </div>
                                                                            </li>
                                                                        )}
                                                                    </Draggable>
                                                                ),
                                                            )}
                                                            {provided.placeholder}
                                                        </ul>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                            <Tab.Pane
                                eventKey="map"
                                onEntered={() => {
                                    setIsOpen(true);
                                }}>
                                {isOpen ? (
                                    <MapRouteCalculatorManager
                                        duration={duration}
                                        setDuration={setDuration}
                                        center={panel.coords}
                                        waypoints={waypoints}
                                        setWaypoints={setWaypoints}
                                        hasChanged={hasChanged}
                                        setHasChanged={setHasChanged}
                                        geojson={geojson}
                                        setGeojson={setGeojson}
                                        tF={_Tf}
                                    />
                                ) : (
                                    <></>
                                )}
                            </Tab.Pane>
                            <Tab.Pane eventKey="programming">
                                <TabProgramming item={item} />
                            </Tab.Pane>
                            <Tab.Pane eventKey="instantiate">
                                <InstantiateRouteStatic routeStaticId={item.id} disabled={hasChanged} />
                            </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                        <div className="buttons-footer buttons-footer pb-3 pe-5">
                            <div className="mt-5 d-flex justify-content-end align-center">
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                    {_Tf("labels.cancel")}
                                </button>
                                <button type="submit" className="btn btn-primary ms-4" disabled={!canSave}>
                                    {_Tf("labels.save")}
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default FormRouteStatic;
